import { useEffect, useState } from 'react'

import { FxAlert, FxButton, FxTextField } from '@/components/fx'

import { ProjektDialog } from './ProjektDialog'

/**
 * Creating a project and renaming one are the same dialog: one required name,
 * submitted with Enter. Kept as a `<form>` so Enter works without a key
 * handler and the browser's own "required" rules apply.
 */
export function FolderNameDialog({
  open,
  mode,
  initialName = '',
  pending,
  error,
  onSubmit,
  onOpenChange,
}: {
  open: boolean
  mode: 'create' | 'rename'
  initialName?: string
  pending?: boolean
  error?: string | null
  onSubmit: (name: string) => void
  onOpenChange: (open: boolean) => void
}) {
  const [name, setName] = useState(initialName)

  // The dialog is mounted for the life of the screen, so the field has to be
  // reset when it opens — otherwise a rename would start from the previous
  // project's name.
  useEffect(() => {
    if (open) setName(initialName)
  }, [open, initialName])

  const trimmed = name.trim()
  const title = mode === 'create' ? 'Neues Projekt' : 'Projekt umbenennen'

  return (
    <ProjektDialog open={open} onOpenChange={onOpenChange} title={title}>
      <form
        className="flex flex-col gap-5"
        onSubmit={(event) => {
          event.preventDefault()
          if (!trimmed || pending) return
          onSubmit(trimmed)
        }}
      >
        <FxTextField
          label="Name des Projekts"
          required
          autoFocus
          value={name}
          maxLength={120}
          onChange={(event) => setName(event.target.value)}
        />
        {error && <FxAlert tone="danger">{error}</FxAlert>}
        <div className="flex flex-wrap justify-end gap-4">
          <FxButton variant="outlined" onClick={() => onOpenChange(false)}>
            Abbrechen
          </FxButton>
          <FxButton type="submit" disabled={!trimmed || pending}>
            {mode === 'create' ? 'Projekt anlegen' : 'Speichern'}
          </FxButton>
        </div>
      </form>
    </ProjektDialog>
  )
}
